import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { FormattedMessage } from 'react-intl';
import Select from "react-select";
import { createDiagnosticSubjectLevelCall } from '../../server/diagnosticsCall/diagnostics-call';
import { onGradeCall } from "../../server/getLessonGradesCall/lesson-grade-call";
import { onSubjectCall } from "../../server/getLessonSubjectCall/lesson-subject-call";
import { FaSave, FaArrowLeft } from "react-icons/fa";
class ModalDiagnosticCreate extends Component {

  constructor(props) {
    super(props);
    this.state = {
      lessonSubject: "",
      lessonGrade: "",
      grades: [],
      subjects: [],
	  isLoading: false,
    };

    this.createDiagnosticSubjectLevel = this.createDiagnosticSubjectLevel.bind(this);
    this.sendComment = this.sendDiagnostic.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.getGrades = this.getGrades.bind(this);
    this.getSubjects = this.getSubjects.bind(this);
  }


  getGrades() {
    onGradeCall(undefined).then((data) => {
      const grades = data.map((item) => ({
        value: item.code,
        label: item.title,
      }));

      this.setState({ grades: grades });
    })
      .catch((error) => {
        alert(error);
      });
  };
  getSubjects() {
    onSubjectCall().then((data) => {
      const subjects = data.map((item) => ({
        value: item.code,
        label: item.title,
      }));
      this.setState({ subjects: subjects });
    })
      .catch((error) => {
        alert(error);
      });
  }

  sendDiagnostic(diagnosticSubjectLevelModel) {
	this.setState({ isLoading: true });

	createDiagnosticSubjectLevelCall(this.props.language, diagnosticSubjectLevelModel).then((response) => {
		if(response) {
			this.props.loadDiagnostics();
			this.onCloseModal();
		}
		this.setState({ isLoading: false });
	  })
	  .catch((error) => {
		alert(error);
		this.setState({ isLoading: false });
	  });
  }

  createDiagnosticSubjectLevel() {
    const diagnosticSubjectLevelModel = {
      SubjectCode: this.state.lessonSubject,
      LevelCode: this.state.lessonGrade
    };

	this.sendDiagnostic(diagnosticSubjectLevelModel);
  }

  onChange(field, value) {
    this.setState({ [field]: value });
  }

  onCloseModal() {
    this.setState({
      lessonSubject: null,
      lessonGrade: "",
      validateLessonSubject: false,
      validateLessonGrade: false
    }, () => this.props.closeModal());
  }

  componentDidMount() {
    this.getGrades();
    this.getSubjects();
  }

  render() {
    return (
      <div>
        <Modal show={this.props.modalOpen} onHide={this.onCloseModal} size="sm">
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs={3} md={2}><FormattedMessage id="cl-select-subject" /></Col>
              <Col xs={9} md={10}>
                <div className="wrapper-content-select">
                  <Select
                    bsSize="small"
                    value={this.state.subjects.find((item) => item.value === this.state.lessonSubject)}
                    onChange={(selected) => this.onChange("lessonSubject", selected.value)}
                    options={this.state.subjects}
                    placeholder={ <FormattedMessage id="d-options-selection" /> }
                  />
                </div>
              </Col>
            </Row>
            <br />
            <Row>
              <Col xs={3} md={2}><FormattedMessage id="cl-select-grade" /></Col>
              <Col xs={9} md={10}>
                <div className="wrapper-content-select">
                  <Select
                    bsSize="small"
                    value={this.state.grades.find((item) => item.value === this.state.lessonGrade)}
                    onChange={(selected) => this.onChange("lessonGrade", selected.value)}
                    options={this.state.grades}
                    placeholder={ <FormattedMessage id="d-options-selection" /> }
                  />
                </div>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="warning" onClick={this.onCloseModal}>
              <FaArrowLeft /><FormattedMessage id="d-cancel-diagnostic" />
            </Button>
            <Button variant="warning" onClick={this.createDiagnosticSubjectLevel} disabled={this.state.isLoading || this.state.lessonSubject === "" || this.state.lessonGrade === ""}>
              <FaSave /> <FormattedMessage id="d-save-diagnostic" />
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default ModalDiagnosticCreate;